module.exports = __webpack_public_path__ + "static/transaction_fee_management2@3x-d8f007335a5e306f5cd6d470fd76aa2b.png";